import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

const Contactus = () => {
    const navigate = useNavigate();

  const handleClose = () => {
    navigate("/");
  };

  return (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-10 mt-32 md:mt-24">
      <div className="relative bg-white shadow-xl rounded-xl p-8 max-w-2xl w-full">
          <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-red-500"
          aria-label="Close"
        >
          <X className="h-6 w-6" />
        </button>
        <h1 className="text-3xl font-bold text-blue-700 mb-4 text-center">
           Contact Us
        </h1>
        <p className="text-gray-700 mb-6 text-center text-sm">
          Facing issues with trips, payments, or documents? We're here for you. Reach out below.
        </p>

        <div className="space-y-4 text-md text-gray-800">
        <p><strong>Company Name:</strong>{" "} The Great Himalayas Cab Service </p>
          <p>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:TGH_Operations@thegreathimalayas.com"
              className="text-blue-500 hover:underline"
            >
              TGH_Operations@thegreathimalayas.com
            </a>
          </p>
          <p>
            <strong>Phone:</strong>{" "}
            <a href="tel:+91 9883587965" className="text-blue-500 hover:underline">
              +91 9883587965
            </a>
          </p>
          
          <p>
            <strong>Office Address:</strong><br />
            Siliguri, Darjeling(Dist), West Bengal, 734001
          </p>
        </div>

        <p className="text-sm text-center text-gray-500 mt-8">
          🚗 Safe drives. Happy journeys. We’ve got your back!
        </p>
      </div>
    </div>
  );
};

export default Contactus;
